<template>
  <div v-if="bbox">
    <p class="panel-subtitle">{{ $t('names.map') | capitalize }}</p>
    <l-map
      style="height: 350px; width: 100%"
      ref="map"
      :center="mapCenter"
      :bounds="bounds"
    >
      <l-tile-layer :url="tileLayerURL" />
      <l-polygon
        color="red"
        dashArray="5, 5"
        fillColor="red"
        :fillOpacity="0.05"
        :interactive="false"
        :lat-lngs="bboxPolygon"
      />
    </l-map>
  </div>
</template>

<script>
import axios from 'axios'
import { LMap, LTileLayer, LPolygon } from 'vue2-leaflet'
import { lib } from '@giscube/geoportal'
const getWMSbbox = lib.geomUtils.getWMSbbox
const L = lib.L

export default {
  props: [
    'layerDescriptor',
    'metadata'
  ],
  components: {
    LMap, LTileLayer, LPolygon
  },
  mounted () {
    this.getBbox()
  },
  data () {
    return {
      bbox: null
    }
  },
  computed: {
    tileLayerURL () {
      if (this.$store.state.map?.layers?.baseLayer) {
        return this.$store.state.map.layers.baseLayer.url
      } else {
        return this.$config.basemaps.find(baseMaps => baseMaps.default).url
      }
    },
    bboxPolygon () {
      return this.bbox && [
        [this.bbox[1], this.bbox[0]],
        [this.bbox[3], this.bbox[0]],
        [this.bbox[3], this.bbox[2]],
        [this.bbox[1], this.bbox[2]]
      ]
    },
    bounds () {
      return [[this.bbox[1], this.bbox[0]], [this.bbox[3], this.bbox[2]]]
    },
    layer () {
      return null
    },
    map () {
      return this.$refs.map
    },
    mapCenter () {
      return this.bbox && [(this.bbox[1] + this.bbox[3]) * 0.5, (this.bbox[0] + this.bbox[2]) * 0.5]
    }
  },
  methods: {
    getBbox () {
      const headers = this.$store.getters['auth/headers']
      if (this.metadata && this.metadata.bbox) {
        this.bbox = this.metadata.bbox.split(',').map(coord => parseFloat(coord))
      } else if (this.layerDescriptor.type.toLowerCase() === 'wms') {
        getWMSbbox(this.layerDescriptor.href, { headers }).then(bbox => {
          this.bbox = bbox
        })
      } else if (this.layerDescriptor.type.toLowerCase() === 'geojson') {
        axios.get(this.layerDescriptor.href, { headers }).then(response => {
          this.bbox = L.geoJSON(response.data).getBounds().toBBoxString().split(',').map(coord => parseFloat(coord))
        })
      }
    }
  }
}
</script>

<style>
</style>
